import React, { useRef, useState } from 'react';
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';
import axios from 'axios';

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSending, setIsSending] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseType, setResponseType] = useState(''); // 'success' ou 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setResponseMessage(null);

    try {
      const res = await axios.post('https://apiportfoliov02.onrender.com/api/contact', formData);
      setResponseMessage(res.data.message);
      setResponseType('success');
      setFormData({ name: '', email: '', message: '' }); // Limpa o formulário
    } catch (error) {
      setResponseMessage(error.response?.data?.message || 'Erro ao enviar a mensagem.');
      setResponseType('error');
    } finally {
      setIsSending(false);
        setTimeout(() => {
      setResponseMessage(null);
    }, 4000);
    }
  };

 
  return (
    <section id='contact'>
      <h5>Entrar em contacto</h5>
      <h2>Contacte-me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>abilioaragao02@gmail.com</h5>
            <a href="mailto:abilioaragao02@gmail.com" target='_blank' rel='noreferrer'>Send a Message</a>
          </article>
          <article className='contact__option'>
            <RiMessengerLine className='contact__option-icon' />
            <h4>Messenger</h4>
            <h5>Abílio Aragão</h5>
            <a href="https://m.me/abilio.aragao" target='_blank' rel='noreferrer'>Send a Message</a>
          </article>
          <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <h5>+244954746427</h5>
            <a href="https://api.whatsapp.com/send?phone=+244954746427" target='_blank' rel='noreferrer'>Send a Message</a>
          </article>
        </div>

        {/* FORMULÁRIO DE CONTATO */}
        <form ref={formRef} onSubmit={handleSubmit}>
          <input type="text" name='name' placeholder='Your Full Name' required value={formData.name} onChange={handleChange} />
          <input type="email" name='email' placeholder='Your Email' required value={formData.email} onChange={handleChange} />
          <textarea name="message" rows="7" placeholder='Your Message' required value={formData.message} onChange={handleChange}></textarea>
          <button type="submit" className='btn btn-primary' disabled={isSending}>
            {isSending ? 'Sending...' : 'Send Message'}
          </button>

          {/* MENSAGEM DE RESPOSTA */}
          {responseMessage && (
            <p className={`message ${responseType}`}>
              {responseMessage}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
